import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './GeneralInfoForm.css';

const CasteForm = ({ casteId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [casteName, setCasteName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     // ✅ Fill form if initialData is provided (edit mode)
     useEffect(() => {
          if (initialData && initialData.caste) {
               setCasteName(initialData.caste);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();

          if (!casteName.trim()) {
               setError('Caste name is required');
               return;
          }

          setLoading(true);
          setError('');

          try {
               let url = '';
               let method = 'POST';
               let body = {};

               if (casteId) {
                    // ✅ Edit mode
                    url = `${baseUrl}/updateCasteById/${casteId}`;
                    body = { caste: casteName };
               } else {
                    // ✅ Create mode
                    url = `${baseUrl}/createCaste`;
                    body = { caste: casteName };
               }

               const response = await fetch(url, {
                    method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
               });

               const data = await response.json();

               if (data.status) {
                    alert(casteId ? 'Caste updated successfully' : 'Caste created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/caste');
               } else {
                    setError(data.message || `Failed to ${casteId ? 'update' : 'create'} PYAGROUP`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>

               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="casteName"
                              placeholder=" "
                              autoComplete="off"
                              value={casteName}
                              onChange={(e) => setCasteName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="casteName">Caste Name</label>
                    </div>
               </div>
               {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
               <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginTop: '15px' }}
                    disabled={loading}
               >
                    {loading ? 'Saving...' : 'Save'}
               </button>
          </form>
     );
};

export default CasteForm;
